import { render, staticRenderFns } from "./CateManage.vue?vue&type=template&id=173c259c"
import script from "./CateManage.vue?vue&type=script&lang=js"
export * from "./CateManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports